import {
  ApiNewDokumentPowiazanyDalDto,
  EgibObject,
  LawPerson,
} from '@gk/gk-modules';
import {
  ApplicantRequest,
  ApplicantRequestDto,
  DocumentationFormType,
} from '../../../../shared/base-new-request/base-new-request.model';
import { Shipping } from '../../../../shared/shipping-form/shipping-form.model';

export interface OCNewRequestDto extends ApplicantRequestDto {
  InfoDodatkowe: string;
}

export class OCNewRequest extends ApplicantRequest {
  constructor(
    lawPerson: LawPerson,
    documentationForm: DocumentationFormType,
    shippingForm: Shipping,
    public comments: string,
  ) {
    super(
      lawPerson,
      undefined,
      documentationForm,
      shippingForm,
      undefined,
      undefined,
      undefined,
    );
  }

  static fromAppToApi(
    data: OCNewRequest,
    issueRanges: string[],
    parcels: EgibObject[],
    files: ApiNewDokumentPowiazanyDalDto[],
  ): OCNewRequestDto {
    return {
      ...ApplicantRequest.mapCommonFields({
        data,
        issueRanges,
        files,
        parcels,
      }),
      InfoDodatkowe: data.comments,
    };
  }
}
